import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import download from 'downloadjs';

import { API_ROOT } from '../../../api/constants';

import UserSearchForm from './UserSearchForm';

import * as userActions from '../user.actions';
import * as teamActions from '../../team/team.actions';
import { UserRoles } from '../user.constants';
import { getCurrentUser } from '../user.selectors';

import Button from '../../../ui/button/Button';
import { ContentBlock } from '../../pages/components';
import { Localize } from '../../../locale/localization';

class UserListBlockAdmin extends Component {
  onPrintUsersClick = () => {
    const token = localStorage.getItem('cmore-sisapiiri-token');
    const url = `${API_ROOT}api/users/export`;
    const init = {
      method: 'GET',
      headers: new Headers({
        authtoken: `${token}`,
      }),
    };

    fetch(url, init)
      .then(function(resp) {
        return resp.blob();
      })
      .then(function(blob) {
        download(blob);
      });
  };

  renderHeaderActions = () => {
    const { currentUser } = this.props;
    return (
      <div>
        {currentUser.role === UserRoles.SUPERUSER && (
          <Button onClick={this.onPrintUsersClick}>
            {Localize('action.print.users')}
          </Button>
        )}
        <NavLink to="/admin/users/add">
          <Button icon="#plus">
            {Localize('action.invite.user')}
          </Button>
        </NavLink>
      </div>
    );
  };

  render() {
    return (
      <ContentBlock title={Localize('admin.users')} renderActions={this.renderHeaderActions}>
        <UserSearchForm />
        <footer>
          <NavLink style={{float:'right'}} to="/admin/users">{Localize('admin.to.users')}</NavLink>
        </footer>
      </ContentBlock>
    );
  }
}

const mapStateToProps = state => {
  const currentUser = getCurrentUser(state);
  return {
    currentUser,
  };
};

const ConnectedUserListBlockAdmin = connect(
  mapStateToProps,
  Object.assign({}, userActions, teamActions)
)(UserListBlockAdmin);

export default ConnectedUserListBlockAdmin;



// WEBPACK FOOTER //
// ./src/modules/user/components/UserListBlockAdmin.js